import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ProgressIndicator, SecurityHelper, HelmetWrapper } from 'sarsaparilla';
import ConfirmationBox from '../components/ConfirmationBox';

const steps = [
  'Order Detail',
  'Shopping Cart',
  'Payment',
  'Confirmation'
];

export class CartlessConfirmationPage extends React.Component {
  render() {
    const email = SecurityHelper.getAccount().email;
    const orderID = this.props.confirmation.orderID;
    const reservations = this.props.confirmation.completedReservations;
    const subtotal = this.props.confirmation.subtotal;
    const tax = this.props.confirmation.tax;
    const total = this.props.confirmation.total;
    const modification = this.props.confirmation.modification;

    return (
      <div id="page-body">
        <HelmetWrapper title="Order Confirmation" />
        <section className="cart-progress-wrap">
          <div className="cart-progress-row">
            <div className="rec-grid-12-12">
              <ProgressIndicator steps={steps} activeStep={4} />
            </div>
          </div>
        </section>
        <div className="rec-section-outer-wrap">
          <div className="rec-nested-wrap">
            <div className="rec-page-layout-full-width">
              <ConfirmationBox
                email={email}
                orderID={orderID}
                reservations={reservations}
                subtotal={subtotal}
                tax={tax}
                total={total}
                modification={modification} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CartlessConfirmationPage.propTypes = {
  confirmation: PropTypes.object.isRequired
};

CartlessConfirmationPage.defaultProps = {
  confirmation: {}
};

function select(state) {
  return {
    confirmation: state.permit.order_confirmation
  };
}

CartlessConfirmationPage.displayName = 'CartlessConfirmationPage';

export default connect(select)(CartlessConfirmationPage);
